import { MathtypeGroupModel } from "models/common.model";
import { StepModel } from "models/step.model";

export const stepLearn : StepModel = {
  id: "4",
  theme: "white-theme",
  title: "Tham gia học với 4 bước đơn giản",
  steps: [
    {
      id: "4",
      title: "Tìm kiếm",
      description: "Bước 1",
      image: "./images/common/icons/2904804.png"
    },
    {
      id: "4",
      title: "Học thử",
      description: "Bước 2",
      image: "./images/common/icons/7366336.png"
    },
    {
      id: "4",
      title: "Thanh toán",
      description: "Bước 3",
      image: "./images/common/icons/3459504.png"
    },
    {
      id: "4",
      title: "Vào học",
      description: "Bước 4",
      image: "./images/common/icons/3652196.png"
    }
  ]
};

export const experiment : StepModel = {
  id: "0",
  theme: "blue-theme",
  title: "Trải nghiệm phương pháp học hiện đại",
  steps: [
    {
      id: "0",
      title: "Học mọi lúc mọi nơi",
      image: "./images/common/icons/2904804.png"
    },
    {
      id: "1",
      title: "Chi phí hợp lý",
      image: "./images/common/icons/3459504.png"
    },
    {
      id: "2",
      title: "Tính ứng dụng cao",
      image: "./images/common/icons/9066641.png"
    },
    {
      id: "3",
      title: "Tương tác giảng viên",
      image: "./images/common/icons/3652196.png"
    },
    {
      id: "4",
      title: "Hỗ trợ 24/7",
      image: "./images/common/icons/7366336.png"
    }
  ]
};

export const reportOverview: StepModel = {
  steps: [
      {
        id: "4",
        title: "50.000+",
        description: "Học viên",
        image: "./images/common/icons/idea.png",
      },
      {
        id: "4",
        title: "100+",
        description: "Giảng viên",
        image: "./images/common/icons/906175.png",
      },
      {
        id: "4",
        title: "1.000+",
        description: "Khóa học",
        image: "./images/common/icons/scholarship.png",
      },
      {
        id: "4",
        title: "3.000+",
        description: "Affiate",
        image: "./images/common/icons/2904708.png",
      },
    ],
    theme: "blue-theme",
    id: "4",
    title: "Thông tin chung Học Hiệu Quả",
};

export const abouts = {
  steps: [
      {
        id: "0",
        title: "Trần Ngọc Tân",
        image: "./images/avatar/tan.jpg",
        subTitle:
          "Mình đang theo học khóa Tiếng Anh tại Học Hiệu quả, chương trình dạy rất thực tế và dễ hiểu cho người mất gốc. Chỉ sau 6 tháng mình đã có thể tự tin giao tiếp Tiếng Anh cơ bản và sử dụng được ngay trong công việc hàng ngày. Rất cám ơn Học Hiệu Quả và cô giáo đã nhiệt tình support, mình sẽ tham khảo thêm các khóa nâng cao hơn để thi lấy chứng chỉ Tiếng Anh nữa.",
      },
      {
        id: "1",
        title: "Nguyễn Tiến Đoàn",
        image: "./images/avatar/doan.jpg",
        subTitle:
          "Tôi là nhân viên văn phòng nên không có nhiều thời gian đi học thêm. Nhưng Học Hiệu Quả mang cho tôi trải nghiệm học tập rất thoải mái, mở máy lên là học bất cứ lúc nào cũng được. Bên chăm sóc khách hàng và tư vấn cũng rất nhiệt tình để tìm ra đúng khóa học phù hợp yêu cầu của khách hàng, khi gặp khó khăn gì tôi cũng nhanh chóng được giải quyết ngay. Đây cũng là điều tôi rất thích về Học Hiệu Quả.!",
      },
      {
        id: "2",
        title: "Nguyễn Tuấn Dũng",
        image: "./images/avatar/liem.jpg",
        subTitle:
          "Cám ơn Học Hiệu Quả đã mang đến những khóa học chất lượng, hoàn toàn chủ động chứ không bị phụ thuộc vào ai cả, tôi đã mua tới 6 khóa học bởi những kiến thức rất thực tế mà các bài học mang lại và chắc chắn sẽ sẽ còn mua thêm. Tuy là học online nhưng vẫn được giảng viên hỗ trợ giải đáp thắc mắc nữa. Tôi chắc chắn sẽ đăng ký thêm nhiều khóa học tại đây!",
      },
    ],
    id: "0",
    theme: "white-theme",
    title: "Học viên nói gì về Học Hiệu Quả",
};


export const levels: { name: string; id: number }[] = [
  { name: 'Dễ', id: 1 },
  { name: 'Trung bình', id: 2 },
  { name: 'Khó', id: 3 },
  { name: 'Rất khó', id: 4 }
];

export const publicStatus: { name: string; id: number }[] = [
  { name: 'Tạo mới', id: 0 },
  { name: 'Chờ duyệt', id: 1 },
  { name: 'Công chờ', id: 2 }
];

export const initialCommentConfigure: {
  from: number;
  to: number;
  comment: string;
  isFixed: boolean;
}[] = [
  {
    from: -1,
    to: 49,
    comment:
      'Con chưa nắm vững kiến thức cơ bản, làm bài chưa cẩn thận. Con cần chăm chỉ ôn kiến thức và rèn luyện kỹ năng thành thạo.',
    isFixed: false
  },
  {
    from: 50,
    to: 69,
    comment:
      'Con nắm được kiến thức cơ bản song kỹ năng chưa thành thạo. Cần tích cực rèn luyện để tiến bộ.',
    isFixed: false
  },
  {
    from: 70,
    to: 84,
    comment:
      'Chúc mừng con đã hoàn thành khá tốt bài kiểm tra! Con nắm kiến thức tương đối vững, con cần làm bài cẩn thận để đạt kết quả tốt hơn.',
    isFixed: false
  },
  {
    from: 85,
    to: 94,
    comment:
      'Chúc mừng con đã hoàn thành tốt bài kiểm tra! Con nắm vững kiến thức, kỹ năng khá thành thạo. Con có thể làm tốt hơn nữa nếu tập trung cao và làm bài cẩn thận.',
    isFixed: false
  },
  {
    from: 95,
    to: 100,
    comment:
      'Chúc mừng con đã hoàn thành xuất sắc bài kiểm tra. Con nắm chắc kiến thức, vận dụng thành thạo! Hãy tiếp tục phát huy nhé!',
    isFixed: false
  },
  {
    from: -1,
    to: 100,
    comment: 'Chúc mừng con đã hoàn thành bài kiểm tra!',
    isFixed: true
  }
];

export const percents: { label: string; value: number }[] = [
  { label: '4%', value: 4 },
  { label: '9%', value: 9 },
  { label: '14%', value: 14 },
  { label: '19%', value: 19 },
  { label: '24%', value: 24 },
  { label: '29%', value: 29 },
  { label: '34%', value: 34 },
  { label: '39%', value: 39 },
  { label: '44%', value: 44 },
  { label: '49%', value: 49 },
  { label: '54%', value: 54 },
  { label: '59%', value: 59 },
  { label: '64%', value: 64 },
  { label: '69%', value: 69 },
  { label: '74%', value: 74 },
  { label: '79%', value: 79 },
  { label: '84%', value: 84 },
  { label: '89%', value: 89 },
  { label: '94%', value: 94 },
  { label: '100%', value: 100 }
];

export const percentsFrom: { label: string; value: number }[] = [
  { label: '0%', value: -1 },
  { label: '5%', value: 5 },
  { label: '10%', value: 10 },
  { label: '15%', value: 15 },
  { label: '20%', value: 20 },
  { label: '25%', value: 25 },
  { label: '30%', value: 30 },
  { label: '35%', value: 35 },
  { label: '40%', value: 40 },
  { label: '45%', value: 45 },
  { label: '50%', value: 50 },
  { label: '55%', value: 55 },
  { label: '60%', value: 60 },
  { label: '65%', value: 65 },
  { label: '70%', value: 70 },
  { label: '75%', value: 75 },
  { label: '80%', value: 80 },
  { label: '85%', value: 85 },
  { label: '90%', value: 90 },
  { label: '95%', value: 95 }
];

export const MATHTYPES: MathtypeGroupModel[] = [
  {
      id: 1,
      name: "A",
      maths: [
        { className: "btn_math-1", math: "\\frac{t}{a}" },
        { className: "btn_math-2", math: "\\sqrt{t}" },
        { className: "btn_math-3", math: "t^{2}" },
        { className: "btn_math-4", math: "(t)" },
        { className: "btn_math-5", math: "[t]" },
        { className: "btn_math-6", math: "^1/_4" },
        { className: "btn_math-7", math: "\\sqrt[147]{96}" },
        { className: "btn_math-8", math: "ta_n" },
      ],
    },
    {
      id: 2,
      name: "B",
      maths: [
        { className: "btn_math-80", math: "\\int\\limits_a^b" },
        {
          className: "btn_math-81",
          math: "\\lim\\limits_{x \\to \\infty} \\exp(-x) = 0",
        },
        { className: "btn_math-82", math: "\\sum_{i=1}^{10} t_i" },
        {
          className: "btn_math-83",
          math: "\\displaystyle\\sum_{i=1}^{10} t_i",
        },
      ],
    },
    {
      id: 3,
      name: "Logic",
      maths: [
        { className: "btn_math-30", math: "\\forall" },
        { className: "btn_math-31", math: "\\in" },
        { className: "btn_math-31a", math: "\\notin" },
        { className: "btn_math-31b", math: "\\ni" },
        { className: "btn_math-32", math: "\\exists" },
        { className: "btn_math-33", math: "\\nexists" },
        { className: "btn_math-34", math: "\\epsilon" },
        { className: "btn_math-35", math: "\\neg" },
        { className: "btn_math-37", math: "\\cup" },
        { className: "btn_math-38", math: "\\subset" },
        { className: "btn_math-39", math: "\\supset" },
        { className: "btn_math-37a", math: "\\land" },
        { className: "btn_math-37b", math: "\\lor" },
        { className: "btn_math-37c", math: "\\angle" },
        { className: "btn_math-37d", math: "\\to" },
        { className: "btn_math-37e", math: "\\gets" },
        { className: "btn_math-37f", math: "\\mapsto" },
        { className: "btn_math-37g", math: "\\implies" },
        { className: "btn_math-37h", math: "\\impliedby" },
        { className: "btn_math-37i", math: "\\Rightarrow" },
        { className: "btn_math-37j", math: "\\leftrightarrow" },
      ],
    },
    {
      id: 4,
      name: "Relation",
      maths: [
        { className: "btn_math-40", math: "\\leq" },
        { className: "btn_math-41", math: "\\geq" },
        { className: "btn_math-42", math: "\\ll" },
        { className: "btn_math-43", math: "\\gg" },
        { className: "btn_math-44", math: "\\subset" },
        { className: "btn_math-45", math: "\\supset" },
        { className: "btn_math-46", math: "\\subseteq" },
        { className: "btn_math-47", math: "\\nsubseteq" },
        { className: "btn_math-50", math: "\\sqsubset" },
        { className: "btn_math-51", math: "\\sqsupset" },
        { className: "btn_math-52", math: "\\sqsubseteq" },
        { className: "btn_math-53", math: "\\sqsupseteq" },
      ],
    },
    {
      id: 5,
      name: "Accents",
      maths: [
        { className: "btn_math-90", math: "a'" },
        { className: "btn_math-91", math: "a''" },
        { className: "btn_math-92", math: "\\hat{a}" },
        { className: "btn_math-93", math: "\\bar{a}" },
        { className: "btn_math-94", math: "\\grave{a}" },
        { className: "btn_math-95", math: "\\acute{a}" },
        { className: "btn_math-96", math: "\\dot{a}" },
      ],
    },
];
